import { useNavigate } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { Badge } from '@/components/ui/Badge';
import { ListRow } from '@/components/ui/ListRow';
import { EmptyState, ErrorState } from '@/components/ui/States';
import { SkeletonRows } from '@/components/ui/Skeleton';
import { useAsync } from '@/lib/useAsync';
import { timeAgo } from '@/lib/timeAgo';
import { api } from '@/lib/api';
import { useProjectCtx } from './ProjectLayout';

/** The project's deliverables — the API already filters clients to visibility=CLIENT. */
export function ProjectDeliverablesTab() {
  const { project } = useProjectCtx();
  const navigate = useNavigate();
  const deliverables = useAsync(() => api.listDeliverables(project.id), [project.id]);

  if (deliverables.status === 'loading') return <SkeletonRows rows={4} />;
  if (deliverables.status === 'error') return <ErrorState error={deliverables.error} onRetry={deliverables.reload} />;
  if (deliverables.data.length === 0) {
    return (
      <EmptyState
        icon={FileText}
        title="No deliverables yet"
        description="Reports produced by runs will appear here."
      />
    );
  }

  return (
    <ul className="divide-y divide-border">
      {deliverables.data.map((d) => (
        <ListRow
          key={d.id}
          icon={<FileText className="h-4 w-4" />}
          title={d.title}
          meta={`${d.path} · v${d.version} · updated ${timeAgo(d.updatedAt)}`}
          actions={
            <Badge tone={d.visibility === 'CLIENT' ? 'primary' : 'neutral'}>{d.visibility.toLowerCase()}</Badge>
          }
          onClick={() => navigate(d.id)}
        />
      ))}
    </ul>
  );
}
